import React, { useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import {
  useAddLeaveTypes,
  useLeaveTypesData,
  useUpdateLeaveType,
} from "./hooks/useLeave";
import LeaveTypeModal from "./components/LeaveTypeModal";
import { FaEdit } from "react-icons/fa";
import { showToast } from "../../utils/toastUtils";

const LeaveType = () => {
  const [leaveTypeModal, setLeaveTypeModal] = useState(false);
  const [leaveType, setLeaveType] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [updateForm, setUpdateForm] = useState("");
  const [leaveTypeId, setLeaveTypeId] = useState(null);

  const [buttonDisable, setButtonDisable] = useState(false);

  // Modal Opening or Closing Functions
  const handleClose = () => {
    setUpdateForm("");
    setLeaveType("");
    setShortCode("");
    setLeaveTypeModal(!leaveTypeModal);
    setButtonDisable(false);
  };
  const toggleModal = () => {
    setUpdateForm("");
    setLeaveType("");
    setShortCode("");
    setLeaveTypeModal(!leaveTypeModal);
    setLeaveTypeId(null);
    setButtonDisable(false);
    // setButtonDisable(false);
  };

  // API Hooks Calling
  const { data: leaveTypeDataa } = useLeaveTypesData({ enable: true });
  const { mutate } = useAddLeaveTypes();
  const { mutate: updateLeaveTypes } = useUpdateLeaveType();

  // Handle Add Button Request
  const handleLeaveRequestView = () => {
    setLeaveTypeModal(!leaveTypeModal);
    setUpdateForm("Submit");
  };

  const handleUpdateLeaveType = (row: any, status: string) => {
    setLeaveTypeModal(!leaveTypeModal);
    setLeaveType(row?.LeaveType);
    setUpdateForm(status);
    setShortCode(row?.ShortCode);
    setLeaveTypeId(row?.LeaveTypeId);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!leaveType.trim()) {
      showToast.warning("Please Fill the Leave Type!");
      return;
    } else if (!shortCode.trim()) {
      showToast.warning("Please Fill the Leave Short Code!");
      return;
    } else {
      setButtonDisable(true);
      const body = {
        LeaveType: leaveType,
        ShortCode: shortCode,
      };
      console.log({ leaveType, shortCode });
      if (updateForm === "Submit") {
        mutate(body, {
          onSuccess: () => {
            handleClose();
          },
          onError: () => {
            setButtonDisable(false);
          },
        });
      } else {
        updateLeaveTypes(
          { id: Number(leaveTypeId), body },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              setButtonDisable(false);
            },
          }
        );
      }
    }
  };

  return (
    <>
      <div className="p-2">
        <PageHeader
          title="Leave Type"
          buttons={[
            {
              label: "+ Add Leave Type",
              onClick: () => handleLeaveRequestView(),
              color: "#43B9B2",
            },
            {
              label: "Excel",
              onClick: () => alert("Action 2 clicked"),
              color: "#43B9B2",
            },
          ]}
        />
        <BasicDataTable
          Title="Leave Type List"
          data={leaveTypeDataa?.data || []}
          columns={leaveRequestColumns(handleUpdateLeaveType)}
          tableHeaderButton={true}
        />
        <RouteModal
          isOpen={leaveTypeModal}
          toggle={toggleModal}
          title={updateForm === "Update" ? "Edit Leave Type" : "Add Leave Type"}
          size="md"
          content={
            <LeaveTypeModal
              handleSubmit={handleSubmit}
              leaveType={leaveType}
              setLeaveType={setLeaveType}
              shortCode={shortCode}
              setShortCode={setShortCode}
              handleClose={handleClose}
              updateForm={updateForm}
              buttonDisable={buttonDisable}
            />
          }
        />
      </div>
    </>
  );
};

export default LeaveType;

const leaveRequestColumns = (
  handleUpdateLeaveType: (row: any, Status: string) => void
) => [
  {
    name: "Leave Type",
    selector: (row: { LeaveType: string }) => row.LeaveType,
    sortable: true,
    maxWidth: "40%",
  },
  {
    name: "Short Code",
    selector: (row: { ShortCode: string }) => row.ShortCode,
    sortable: true,
    maxWidth: "40%",
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdateLeaveType(row, "Update")}
        className="btn btn-primary"
        style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
    maxWidth: "20%",
  },
];
